import styled from 'styled-components';

export const StyledQuestionnaireListItem = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  :hover {
    background-color: ${({ theme }) => theme.colors.tone.lightBlue};
    cursor: pointer;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    width: 16px;
    height: 16px;
  }
`;

export const HoverActionButtonContainer = styled.div`
  .hover-action-button {
    color: ${({ theme }) => theme.colors.primary.blue};
    padding: 0;
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const CheckBoxInputContainer = styled.div`
  display: flex;
  gap: 8px;
`;
